exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".homer .icon-logoHomer{width:calc(6.69643vw + 228.57143px);height:calc(1.91964vw + 63.85714px)}.homer p{font-size:calc(.71429vw + 21.71429px)}", ""]);
